export const sorts = [
  {
    title: 'محبوب‌ترین',
    api: 'is_descending[rate]',
    query: 'sortBy',
    aValue: 1,
    qٰValue: 5,
  },
  {
    title: 'ارزان‌ترین',
    api: 'is_descending[price]',
    query: 'sortBy',
    aValue: 0,
    qٰValue: 3,
  },
  {
    title: 'گران‌ترین',
    api: 'is_descending[price]',
    query: 'sortBy',
    aValue: 1,
    qٰValue: 2,
  },
  {
    title: 'نردیک‌ترین',
    api: 'is_descending[distance]',
    query: 'sortBy',
    aValue: 0,
    qٰValue: 7,
  },
]

export const filters = [
  {
    query: 'checkin',
    api: 'checkin_timestamp',
  },
  {
    query: 'checkout',
    api: 'checkout_timestamp',
  },
  {
    query: 'guests',
    api: 'guests',
  },
  {
    query: 'instant',
    api: 'is_instant',
  },
  {
    query: 'guarantee',
    api: 'price_guarantee',
  },
  {
    // hezar toman
    query: 'max_price',
    api: 'max_price',
  },
  {
    // hezar toman
    query: 'min_price',
    api: 'min_price',
  },
  {
    query: 'villa',
    api: 'category[]',
    qValue: 1,
    aValue: 'villa',
  },
  {
    query: 'apartment',
    api: 'category[]',
    qValue: 1,
    aValue: 'apartment',
    seo: true,
    seoTitle: 'آپارتمان',
  },
  {
    query: 'boomgardi',
    api: 'category[]',
    qValue: 1,
    aValue: 'boomgardi',
  },
  {
    query: 'swiss-cottage',
    api: 'category[]',
    qValue: 1,
    aValue: 'swiss_cottage',
    seo: true,
    seoTitle: 'کلبه سوئیسی',
    meta_tags: 'swiss_cottage',
  },
  {
    api: 'category[]',
    query: 'cottage',
    qValue: 1,
    aValue: 'cottage',
  },
  {
    api: 'page',
    query: 'page',
  },
  {
    api: 'late_night',
    query: 'late_night',
    qValue: 1,
    aValue: 1,
  },
  {
    api: 'tag[]',
    query: 'tag',
  },
  {
    api: 'co_ordinates',
    query: 'co_ordinates',
  },
  {
    api: 'is_descending[recent_rank]',
    query: 'is_descending[recent_rank]',
    aValue: 1,
    qValue: 1,
  },
  {
    api: 'phrase',
    query: 'phrase',
  },
  {
    api: 'parent_id',
    query: 'parent_id',
  },
  {
    api: 'near_cities[]',
    query: 'near_cities',
  },
  {
    api: 'source_city',
    query: 'source_city',
  },
  // for پذیرش با کارت ملی
  // {
  //   query: 'national',
  //   api: 'is_for_single_groups',
  // },
]

type IMoreFilters = {
  title?: string
  is_mid_term?: boolean
  gtmKey?: string
  type: 'numberInput' | 'checkbox' | 'switch'
  list: {
    title?: string
    query: string
    api: string
    qValue?: any
    aValue?: any
    seo?: boolean
    seoTitle?: string
    icon?: string
    description?: string
  }[]
}

export const moreFilters: IMoreFilters[] = [
  {
    type: 'switch',
    list: [
      {
        query: 'instant',
        api: 'is_instant',
        qValue: 1,
        aValue: 1,
        title: 'رزرو آنی و قطعی',
        icon: 'flash-Filled',
        description:
          'برای رزرو نهایی این اقامتگاه نیازی به تایید از سمت میزبان نخواهید داشت و رزرو شما قطعی خواهد بود.',
      },
      // {
      //   query: 'guarantee',
      //   api: 'price_guarantee',
      //   qValue: 1,
      //   aValue: 1,
      //   title: 'تضمین کف قیمت',
      //   icon: 'coin-Filled',
      //   description:
      //     'نمایش اقامتگاه‌هایی که در «سایت شب» با کمترین قیمت نسبت به بازار ارائه می‌شوند.',
      // },
      {
        query: 'national',
        api: 'rule[id_only]',
        qValue: 1,
        aValue: 1,
        title: 'امکان پذیرش با کارت ملی',
        icon: 'document-text-Filled',
      },
      // {
      //   query: 'installment_payment',
      //   api: 'installment_payment',
      //   qValue: 1,
      //   aValue: 1,
      //   title: 'پرداخت قسطی',
      //   description: '۴ قسطه با اسنپ پی',
      //   icon: 'card-tick-Filled',
      // },
      {
        query: 'discount_days',
        api: 'discount_days',
        qValue: 1,
        aValue: 1,
        title: 'تخفیف مدت دار ',
        icon: 'percentage-circle-Filled',
      },
      {
        query: 'late_night',
        api: 'late_night',
        qValue: 1,
        aValue: 1,
        title: 'تخفیف لحظه آخری ',
        icon: 'clock-Filled',
        description: 'از ساعت 15:00 به بعد',
      },
    ],
  },
  {
    title: 'تعداد نفرات',
    is_mid_term: true,
    type: 'numberInput',
    gtmKey: 'guest_num_filter',
    list: [
      {
        title: 'تعداد نفرات',
        query: 'guests',
        api: 'guests',
      },
    ],
  },
  {
    title: 'تعداد اتاق',
    is_mid_term: true,
    type: 'numberInput',
    gtmKey: 'room_num_filter',
    list: [
      {
        title: 'تعداد اتاق',
        query: 'bedroom_count',
        api: 'bedroom_count',
      },
    ],
  },
  {
    title: 'نوع اقامتگاه',
    type: 'checkbox',
    gtmKey: 'type_filter',
    list: [
      {
        title: 'خانه ویلایی',
        api: 'category[]',
        query: 'villa',
        qValue: 1,
        aValue: 'villa',
      },
      {
        title: 'ساحلی',
        query: 'coastal',
        api: 'texture_type[]',
        qValue: 1,
        aValue: 3,
        seo: true,
        seoTitle: 'ساحلی',
      },
      {
        title: 'استخردار',
        query: 'pool',
        api: 'pool[exist]',
        qValue: 1,
        aValue: 1,
        seo: true,
        seoTitle: 'استخردار',
      },
      {
        title: 'کلبه',
        api: 'category[]',
        query: 'cottage',
        qValue: 1,
        aValue: 'cottage',
        seo: true,
        seoTitle: 'کلبه',
      },
      {
        title: 'بوم‌گردی',
        api: 'category[]',
        query: 'boomgardi',
        qValue: 1,
        aValue: 'boomgardi',
        seo: true,
        seoTitle: 'بوم گردی',
      },
      {
        title: 'آپارتمان',
        api: 'category[]',
        query: 'apartment',
        qValue: 1,
        aValue: 'apartment',
      },
    ],
  },
  {
    title: 'ویژگی های اقامتگاه',
    type: 'checkbox',
    gtmKey: 'badge_filter',
    list: [
      {
        title: 'رزرو بلندمدت (با تخفیف)',
        query: 'long_term_discount',
        api: 'long_term_discount',
        qValue: 1,
        aValue: 1,
      },
      {
        title: 'امکان پذیرش 24 ساعته',
        query: 'twenty_four_hour',
        api: 'rule[twenty_four_hour_entry]',
        qValue: 1,
        aValue: 1,
      },
      {
        title: 'امکان برگزاری مراسم',
        query: 'rule_ceremony',
        api: 'rule[ceremony_allowed]',
        qValue: 1,
        aValue: 1,
      },
      {
        title: 'امکان ورود حیوانات خانگی',
        query: 'rule_pets',
        api: 'rule[pets_allowed]',
        qValue: 1,
        aValue: 1,
      },
      // {
      //   title: 'مناسب سالمندان و معلولین',
      //   query: 'suitable-for-elderly-and-children',
      //   api: 'extended_features[]',
      //   qValue: 1,
      //   aValue: 'suitable-for-elderly-and-children',
      // },
      {
        title: 'دربست',
        query: 'detached',
        api: 'detached',
        qValue: 1,
        aValue: 1,
      },
      {
        title: 'حیاط در اختیار',
        query: 'private_yard',
        api: 'not_shared_features[]',
        qValue: 1,
        aValue: 'yard',
      },
    ],
  },
  {
    title: 'نوع محل',
    type: 'checkbox',
    gtmKey: 'geo_filter',
    list: [
      {
        title: 'جنگلی',
        query: 'forest',
        api: 'texture_type[]',
        qValue: 1,
        aValue: 4,
        seo: true,
        seoTitle: 'جنگلی',
      },
      {
        title: 'کوهستانی',
        query: 'mountain',
        api: 'texture_type[]',
        qValue: 1,
        aValue: 6,
        seo: true,
        seoTitle: 'کوهستانی',
      },
      {
        title: 'کویری',
        query: 'desert',
        api: 'texture_type[]',
        qValue: 1,
        aValue: 5,
        seo: true,
        seoTitle: 'کویری',
      },
      {
        title: 'شهری',
        query: 'in_town',
        api: 'texture_type[]',
        qValue: 1,
        aValue: 1,
      },
    ],
  },
  {
    title: 'امکانات اقامتگاه',
    is_mid_term: true,
    type: 'checkbox',
    gtmKey: 'features_filter',
    list: [
      {
        title: 'باربیکیو',
        query: 'barbecue',
        api: 'features_any[]',
        qValue: 1,
        aValue: 'charcoal_barbecue,gas_barbecue',
        seo: true,
        seoTitle: 'باربیکیو (منقل)',
      },
      {
        title: 'اینترنت رایگان',
        query: 'wifi',
        api: 'features[]',
        qValue: 1,
        aValue: 'wifi_internet',
      },
      {
        title: 'بیلیارد',
        query: 'billiard-pool',
        api: 'features[]',
        qValue: 1,
        aValue: 'billiard_table',
        seo: true,
        seoTitle: 'با میزبیلیارد',
      },
      {
        title: 'جکوزی',
        query: 'jacuzzi',
        api: 'features[]',
        qValue: 1,
        aValue: 'hot_tub',
      },
      {
        title: 'سونا',
        query: 'suna',
        api: 'features_any[]',
        qValue: 1,
        aValue: 'steam_sauna,dry_sauna',
      },
      {
        title: 'حمام',
        query: 'bathroom',
        api: 'features[]',
        qValue: 1,
        aValue: 'bathroom',
      },
      {
        title: 'گرمایش',
        query: 'heating',
        api: 'features_category[]',
        qValue: 1,
        aValue: 'heating_system',
      },
      {
        title: 'کولر آبی',
        query: 'water_cooling',
        api: 'features[]',
        qValue: 1,
        aValue: 'water_air_condition',
      },
      {
        title: 'کولر گازی',
        query: 'split_cooling',
        api: 'features[]',
        qValue: 1,
        aValue: 'gas_air_condition',
      },
      {
        title: 'پارکینگ',
        query: 'parking',
        api: 'parking[capacity]',
        qValue: 1,
        aValue: 1,
      },
      {
        title: 'استخر سر پوشیده',
        query: 'indoor_pool',
        api: 'pool[type]',
        qValue: 1,
        aValue: 'indoor',
        seo: true,
        seoTitle: 'با استخر سرپوشیده',
      },
      {
        title: 'استخر رو باز',
        query: 'outdoor_pool',
        api: 'pool[type]',
        qValue: 1,
        aValue: 'outdoor',
        seo: true,
        seoTitle: 'با استخر رو باز',
      },
      {
        title: 'استخر آب گرم',
        query: 'warm_water_pool',
        api: 'pool[has_warm_water]',
        qValue: 1,
        aValue: 1,
        seo: true,
        seoTitle: 'استخردار',
      },
      {
        title: 'سرویس فرنگی',
        query: 'toilet',
        api: 'features[]',
        qValue: 1,
        aValue: 'european_wc',
      },
      {
        title: 'تراس',
        query: 'balcony',
        api: 'features[]',
        qValue: 1,
        aValue: 'terrace',
        seo: true,
        seoTitle: 'تراس دار (بالکن)',
      },
      {
        title: 'آسانسور',
        query: 'elevator',
        api: 'features[]',
        qValue: 1,
        aValue: 'elevator',
      },
      {
        title: 'مبلمان',
        query: 'furniture',
        api: 'features[]',
        qValue: 1,
        aValue: 'furniture',
      },
      {
        title: 'تجهیزات آشپزی',
        query: 'kitchen_equipments',
        api: 'features[]',
        qValue: 1,
        aValue: 'kitchen',
      },
      {
        title: 'تلویزیون',
        query: 'tv',
        api: 'features[]',
        qValue: 1,
        aValue: 'television',
      },
      {
        title: 'گیرنده دیجیتال',
        query: 'receiver',
        api: 'features[]',
        qValue: 1,
        aValue: 'digital_receiver',
      },
      {
        title: 'صبحانه',
        query: 'breakfast',
        api: 'features[]',
        qValue: 1,
        aValue: 'breakfast',
      },
    ],
  },
]

const useMoreFilters = () => {
  const selectedMoreFilters = queryParams => {
    const list = moreFilters.flatMap(item => item.list).map(item => item.query)
    const selected = {}
    Object.entries(queryParams).forEach(([key, value]) => {
      if (value) {
        if (list?.includes(key as string)) {
          selected[key] = value
        }
      }
    })
    return selected
  }

  const clearFilters = queryParams => {
    const list = [...filters, ...moreFilters.flatMap(item => item.list)].map(
      item => item.query,
    )
    const queries = {}
    Object.entries(queryParams).forEach(([key, value]) => {
      queries[key] = list?.includes(key as string) ? undefined : value
    })
    return queries
  }

  const updateQueries = ({ form, setQuery }) => {
    const list = moreFilters.flatMap(item => item.list)
    const query = {}

    list.forEach(item => {
      const field = form[item.query]
      if (field) {
        query[item.query] = item.qValue ?? field
      } else {
        query[item.query] = undefined
      }
    })
    setQuery(query)
  }

  const getSeoTexts = ({ queryParams }) => {
    const list = moreFilters.flatMap(item => item.list)
    const selected = Object.keys(selectedMoreFilters(queryParams))
    const selectedSeoItems: object[] = []

    list.forEach(item => {
      if (item.seo && selected?.includes(item.query)) {
        selectedSeoItems.push(item)
      }
    })

    return selectedSeoItems
  }

  const isNotMidTermFilters = moreFilters
    .filter(item => !item.is_mid_term)
    ?.flatMap(item => item.list)

  return {
    selectedMoreFilters,
    clearFilters,
    updateQueries,
    getSeoTexts,
    isNotMidTermFilters,
    moreFilters,
  }
}

export default useMoreFilters
